import { Trophy, GraduationCap, Flame, Users } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";
import { IMAGES, FOUNDER_CREDENTIALS } from "../../data/content";

const ICONS = { Trophy, GraduationCap, Flame, Users };

export const Founder = () => {
  return (
    <section id="founder" className="relative bg-[#0b1528] py-24 sm:py-32 px-5 sm:px-8" data-testid="founder-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-[380px_1fr] gap-14 items-start">
        <ScrollReveal className="relative">
          <div className="relative rounded-[2rem] overflow-hidden aspect-[3/4] glow-border" data-testid="founder-photo-frame">
            <img
              src={IMAGES.founder}
              alt="Mr. Srinivas Reddy MB, founder of MindBodyLife.pro, wearing his championship medals — Strength, Discipline, Dedication"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-4 sm:-right-8 bg-[#020617] border border-cyan-500/25 rounded-2xl px-5 py-4 glow-border">
            <div className="font-display font-extrabold text-2xl text-white">16+</div>
            <div className="font-mono-brand text-[10px] uppercase tracking-widest text-cyan-400">Years Experience</div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.15}>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">About The Founder</span>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl text-white mt-4 leading-tight">
            Mr. Srinivas Reddy MB
          </h2>
          <p className="text-sm text-cyan-300 font-medium mt-2 uppercase tracking-wide">
            International Athlete · Exercise Science Specialist · Health &amp; Fitness Expert
          </p>

          <p className="text-slate-400 mt-6 text-sm sm:text-base leading-relaxed max-w-2xl">
            Founded with one powerful mission — to make quality health &amp; fitness guidance accessible to
            millions. Over the years, Srinivas Reddy has worked with thousands of individuals, leading to one
            important realization: <span className="text-white font-medium">people don't just need more workouts, they need a complete system</span>{" "}
            that connects fitness, nutrition, mindset, lifestyle, daily habits and long-term consistency.
          </p>

          <div className="grid sm:grid-cols-2 gap-4 mt-9">
            {FOUNDER_CREDENTIALS.map((c) => {
              const Icon = ICONS[c.icon];
              return (
                <div
                  key={c.label}
                  className="flex items-center gap-3 rounded-xl bg-white/[0.03] border border-slate-800 px-4 py-3.5"
                  data-testid={`founder-credential-${c.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <Icon size={18} className="text-cyan-400 shrink-0" />
                  <span className="text-sm text-slate-200 font-medium">{c.label}</span>
                </div>
              );
            })}
          </div>

          <p className="mt-8 font-display uppercase font-bold text-lg sm:text-xl text-white">
            This is more than fitness. <span className="text-gradient-cyan">This is a movement.</span>
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
};
